"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@app/_context";
import Link from "@components/Link";

export default function CheckoutEmpty() {
  const t = useTranslate();
  const { locale } = useMarket().state.market;

  return (
    <div className="px-6 py-8">
      <p className="text-xl">{t("noItemsInCart")}</p>
      <Link href="/" locale={locale} className="mt-4 inline-block underline">
        {t("continueShopping")}
      </Link>
    </div>
  );
}
